import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

// ScalarSpreadsheet always renders an empty title-columns container (~12px
// wide) and a 12px paddingTop above the content scroll area, even when the
// sheet has no titles column or scrollbar. For the cross-ref popup we don't
// want either of those gaps. Scoping these overrides to PopupPaper keeps
// other sheets unaffected.
export const PopupPaper = styled(Paper)(() => ({
  padding: 0,
  background: '#fff',
  display: 'inline-block',
  '& #spreadsheet-table__title-columns': {
    display: 'none',
  },
  '& [style*="padding-top: 12px"]': {
    paddingTop: '0 !important',
  },
  '& .ContentColumns-columnsContent': {
    height: 'fit-content !important',
  },
}));
